// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./components/accordion/style/index.less
 ** module id = 286
 ** module chunks = 0
 **/